import React from "react";
import "./footer.css";
import { RiInstagramFill } from "react-icons/ri";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaQuora } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer_logo">
        Pranav
      </a>
      <div className="footer_right">
        <div className="footer_socials">
          <a href="https://www.instagram.com/_imroz._/" target="_blank">
            <RiInstagramFill />
          </a>
          <a href="https://twitter.com/im__perfect_" target="_blank">
            <FaSquareXTwitter />
          </a>
          <a
            href="https://www.quora.com/profile/Pranav-Tripathi-58"
            target="_blank"
          >
            <FaQuora />
          </a>
        </div>

        <ul className="permalinks">
          <li>
            <a href="#">Home</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#experience">Work Experience</a>
          </li>
          <li>
            <a href="#projects">Projects</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#testimonials">Testimonials</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </div>

      <div className="footer_copyright">
        <small>&copy; All Rights Reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
